import type { Dispatch, FC, SetStateAction } from "react";

import { Stack } from "@mui/material";
import CustomDropdown from "../../../CustomDropdown";
import CustomTextField from "../../../CustomTextField";

import { summaryModalDropdownItems } from "../../../../constants/notifications";

import { useTranslation } from "react-i18next";

interface SettingsTabSummaryModalCaseProps {
  selectedVariant?: "visitorSummary" | "registrationSummary" | "orderSummary";
  text?: string;
  setText?: Dispatch<SetStateAction<string>>;
  setSelectedVariant?: Dispatch<
    SetStateAction<"visitorSummary" | "registrationSummary" | "orderSummary">
  >;
}

export const SettingsTabSummaryModalCase: FC<
  SettingsTabSummaryModalCaseProps
> = ({ selectedVariant, text, setText, setSelectedVariant }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='column'
      sx={{
        pt: 1,
        gap: 3,
        py: 2,
      }}
    >
      <CustomDropdown
        width='100%'
        value={selectedVariant}
        label={t("campaign.notifications.settings.displayRules.choseVariant")}
        items={summaryModalDropdownItems.map(item => {
          return {
            value: item.value,
            title: t(
              "campaign.notifications.settings.displayRules.visitorSummary." +
                item.title,
            ),
          };
        })}
        onChange={event => {
          if (setSelectedVariant) {
            setSelectedVariant(event.target.value as any);
          }
        }}
      />
      <CustomTextField
        fullWidth
        label={
          t(
            "campaign.notifications.settings.displayRules.actualVisitors.nameVisitors",
          ) ?? ""
        }
        value={text ?? ""}
        onChange={e => {
          if (setText) {
            setText(e.currentTarget.value);
          }
        }}
      />
    </Stack>
  );
};
